import React from 'react'

import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {Object}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a notification icon.
 *
 * @function
 * @param {Object} [props] - The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <NotificationIcon width={12} />
 */
const NotificationIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M44.89 32.854L30.445 8.206c-1.493-2.688-3.832-4.227-6.42-4.227-2.59
            0-4.93 1.54-6.424 4.226L3.162 32.79c-1.472 2.652-1.562 5.454-.247 7.69
            1.315 2.236 4.057 3.564 7.088 3.564H38.05c3.03 0 5.772-1.266 7.087-3.502
            1.313-2.236 1.223-5.037-.248-7.688zM24.02 40.34c-2.125 0-3.85-1.725-3.85-3.854
            0-2.133 1.726-3.858 3.85-3.858 2.135 0 3.86 1.726 3.86 3.858 0 2.13-1.725
            3.854-3.86 3.854zm2.9-12.752c-.113 1.592-1.297 2.59-2.89 2.59-1.6
            0-2.783-1.015-2.896-2.59-.12-1.575-.965-12.46-.965-12.46 0-1.905
            1.726-3.454 3.86-3.454 2.125 0 3.85 1.548 3.85 3.454 0 0-.85
            10.865-.96 12.46z`}
        />
    </SvgIcon>
)

NotificationIcon.defaultProps = defaultProps

export { NotificationIcon }
